import { Injectable } from '@angular/core';
import { isNil, reject } from 'lodash-es';

import { ApplicationAdapter } from 'application/application.adapter';
import { OrganizationPropertyOutput } from 'organization/model/organization-property.output';
import { OrganizationProperty } from 'organization/organization-property';
import { OrganizationPropertiesConverterPort } from 'organization/property/port/organization-properties-converter.port';

@Injectable()
export class OrganizationPropertiesConverterAdapter
	extends ApplicationAdapter
	implements OrganizationPropertiesConverterPort
{
	public organizationPropertyAsEntity(
		output: OrganizationPropertyOutput
	): OrganizationProperty {
		if (!output) {
			return null;
		}
		return new OrganizationProperty(output.name, output.type, output.value);
	}

	public organizationPropertiesAsEntities(
		outputs: OrganizationPropertyOutput[]
	): OrganizationProperty[] {
		return reject(outputs, isNil).map((output) =>
			this.organizationPropertyAsEntity(output)
		);
	}
}
